import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { sofaTypes } from '@sofa-platform/range-data-generator/type-object'
import { isKeyOf } from '@sofa-platform/types'

import { dexfSettingsQueryOptions, rangeDataQueryOptions } from '@/query-options'
import { getLocaleFromPath } from '@/utils/base-path-params'
import { redirectHome, redirectToScene } from '@/utils/redirects'

const sofaRangeNames = [...Object.keys(sofaTypes), 'future']
const itemNoValidator = z.string().length(8, 'Invalid product id')
const rangeNameValidator = z.enum(sofaRangeNames, 'Invalid rangeId')

export const Route = createFileRoute('/$country/$language/navigator/$')({
  beforeLoad: async ({ context, params }) => {
    const { _splat } = params
    if (!_splat) {
      throw redirectHome(Route.fullPath)
    }
    const dexfSettings = await context.queryClient.ensureQueryData(dexfSettingsQueryOptions(getLocaleFromPath()))
    const rangeData = await context.queryClient.ensureQueryData(rangeDataQueryOptions(dexfSettings))

    // e.g /latest/se/sv/navigator/vimle
    if (rangeNameValidator.safeParse(_splat).success && isKeyOf(_splat, rangeData)) {
      const rangeId = _splat
      const firstValidSofaIdInRange = rangeData[rangeId].sofas.at(0)?.itemNo
      if (!firstValidSofaIdInRange) {
        throw redirectHome(Route.fullPath)
      }
      throw redirectToScene(Route.fullPath, rangeId, firstValidSofaIdInRange)
    }
    // e.g /latest/se/sv/navigator/12345678
    if (itemNoValidator.safeParse(_splat).success) {
      const potentialSofaId = _splat
      const sofa = Object.values(rangeData)
        .flatMap((r) => r.sofas)
        .find((sofa) => sofa.itemNo === potentialSofaId || sofa.productData.content.itemNoLocal === potentialSofaId)
      if (!sofa) {
        throw redirectHome(Route.fullPath)
      }
      throw redirectToScene(Route.fullPath, sofa.rangeId, sofa.itemNo)
    }
    throw redirectHome(Route.fullPath)
  },
})
